import PortalDialogType from "../PortalDialogType";
import DefaultParameters from "./DefaultParameters";
import Parameter from "./Parameter";
import MimeTypeFilter from "../../document/mimetype/MimeTypeFilter";
import MimeTypes from "../../document/mimetype/MimeTypes";
import PortalDocument from "../../document/PortalDocument";
import FileTypeGroupFilter from "../../document/mimetype/FileTypeGroupFilter";
import FileTypeGroup from "../../document/mimetype/FileTypeGroup";
import {PAGERANGE_ALL} from "../../document/PageSelection";
import {PATH_SEPARATOR} from "../../../shared/helper/FileHelper";
import {
	BackgroundFunction,
	PortalBackgroundToolboxOptions
} from "../../../shared/models/PortalBackgroundToolboxOptions";
import {OptionsType as PositionsOptionsType, OptionsTypeDate} from "../../../shared/models/HeaderFooterOptions";
import {
	AttachmentMode,
	Axis,
	AztecBarcode,
	BackgroundPositionMode,
	BarcodeCreateOutputFormat,
	BarcodeDetectInputFormat,
	BarcodeDetectOutputFormat,
	BarcodeSelection,
	BorderStyle,
	CertificationLevel,
	CodabarBarcode,
	Code128Barcode,
	Code39Barcode,
	ConverterHtmlErrorReportFormat,
	ConverterHtmlErrorReportMode,
	DataMatrixBarcode,
	DataMatrixShape,
	DescriptionCustom,
	DrawMode,
	Duplex,
	Ean13Barcode,
	Ean8Barcode,
	ExtractionFileFormat,
	ExtractionImageFormat,
	Failure,
	FileAttachment,
	FileDataFormat,
	FileDataSource,
	FontOriginMode,
	FormsExport,
	FormsFormat,
	FormsImport,
	Icons,
	InitialView,
	ItemReference,
	ItfBarcode,
	KeyStorePassword,
	Magnification,
	MarkupsAnnotation,
	MergeMode,
	Metrics,
	MoveMode,
	NonFullScreenPageMode,
	OcrLanguage,
	OcrOutput,
	OptimizationIntensity,
	Order,
	OrientationDetection,
	PageBox,
	PageGroup,
	PageLayout,
	PageOrientation,
	Parameter as ParameterType,
	Pdf417CompactionMode,
	PdfaErrorReport,
	PdfaLevel,
	PdfContentEncryption,
	PdfEncryptionKey,
	PortfolioFile,
	PortfolioFolder,
	PortfolioSelection,
	PrintMode,
	PrintScale,
	PrintTraySelection,
	QrBarcode,
	QrCodeErrorCorrection,
	QrSwissPaymentBarcode,
	QrSwissPaymentContentFormat,
	QrSwissPaymentFormat,
	QrSwissPaymentLanguage,
	QrSwissPaymentPdfMode,
	QrSwissPaymentSeparator,
	Recipient,
	Rectangle,
	RemoveBoxes,
	RemovePageTransitions,
	ReplyToAnnotation,
	ReplyToAnnotationEdit,
	RubberStampIcon,
	SelectionAnnotation,
	SelectionAttachment,
	Signature,
	SignatureImagePosition,
	SplitMode,
	SvgGraphicsStateMode,
	SvgPathDrawMode,
	TextAnnotationIcons,
	TextDirection,
	TextWrapMode,
	TiffCompression,
	ToolboxAnnotationAnnotation,
	ToolboxAttachmentAttachment,
	ToolboxCompressCompress,
	ToolboxDeleteDelete,
	ToolboxDescriptionDescription,
	ToolboxFormsForms,
	ToolboxMoveMove,
	ToolboxPrintPrint,
	ToolboxRedactRedact,
	ToolboxRotateRotate,
	ToolboxSecuritySecurity,
	ToolboxSplitSplit,
	ToolboxTranscribeTranscribe,
	TranscribeErrorReport,
	TranscribeSuccessReport,
	TransitionDirection,
	TransitionStyle,
	UpcaBarcode,
	WatermarkPositionMode,
	XslTransformationFile,
	ZugferdVersion
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {
	ConverterType,
	PortalConverter,
	TransformationSystemLanguage,
	XmlMode
} from "../../../shared/models/PortalConverter";
import {PortalPage} from "../../../shared/models/PortalPage";
import {PortalRename} from "../../../shared/models/PortalRename";
import {PortalToolboxWatermarkWatermark, WatermarkMode} from "../../../shared/models/PortalToolboxWatermarkWatermark";
import {PortalWatermarkFileData} from "../../../shared/models/PortalWatermarkFileData";
import {
	ExtractionMode,
	PortalToolboxExtractionExtraction
} from "../../../shared/models/PortalToolboxExtractionExtraction";
import {ImageFormat, PortalToolboxImageImage} from "../../../shared/models/PortalToolboxImageImage";
import {PortalToolboxSplitSplit} from "../../../shared/models/PortalToolboxSplitSplit";
import {PortalToolboxOptionsOptions} from "../../../shared/models/PortalToolboxOptionsOptions";
import {BackgroundMode, PortalAddBackground} from "../../../shared/models/PortalAddBackground";
import {PortalImageBackground} from "../../../shared/models/PortalImageBackground";
import {PortalColorBackground} from "../../../shared/models/PortalColorBackground";
import {PortalBackgroundBaseSettings} from "../../../shared/models/PortalBackgroundBaseSettings";
import {PortalPagesBackgroundBaseSettings} from "../../../shared/models/PortalPagesBackgroundBaseSettings";
import {PortalBackgroundFileData} from "../../../shared/models/PortalBackgroundFileData";
import {
	HeaderFooterFunction,
	PortalHeaderFooterToolboxOptions
} from "../../../shared/models/PortalHeaderFooterToolboxOptions";
import {PortalPagesHeaderFooter} from "../../../shared/models/PortalPagesHeaderFooter";
import {PortalHeaderFooterPositions} from "../../../shared/models/PortalHeaderFooterPositions";
import {BoxesFunction, PortalBoxesToolboxOptions,} from "../../../shared/models/PortalBoxesToolboxOptions";
import {PagesAddModeEnum, PortalPagesAdd} from "../../../shared/models/PortalPagesAdd";
import {PdfaMode, PortalPdfa} from "../../../shared/models/PortalPdfa";
import {PortalZugferdFileData} from "../../../shared/models/PortalZugferdFileData";
import {OcrPdfaType, PortalOcr} from "../../../shared/models/PortalOcr";
import {PortalOcrPage} from "../../../shared/models/PortalOcrPage";
import {PortalAddSignature} from "../../../shared/models/PortalAddSignature";
import {PortalSignatureFileData} from "../../../shared/models/PortalSignatureFileData";
import {PortalFormsFileData} from "../../../shared/models/PortalFormsFileData";
import {PortalToolboxOutlineOutline} from "../../../shared/models/PortalOutlineType";
import {PortalActionEvent} from "../../../shared/models/PortalActionEvent";
import {PortalItem, PortalItemPosition} from "../../../shared/models/PortalItem";
import {PortalAddToolboxOutline} from "../../../shared/models/PortalAddToolboxOutline";
import {PortalBarcode} from "../../../shared/models/PortalBarcode";
import {PortalAddBarcode, PortalBarcodeFormat} from "../../../shared/models/PortalAddBarcode";
import {PortalPdf417Barcode} from "../../../shared/models/PortalPdf417Barcode";
import {MergeOperation, PortalToolboxMergeMerge} from "../../../shared/models/PortalToolboxMergeMerge";
import {PortalToolboxPortfolioPortfolio} from "../../../shared/models/PortalToolboxPortfolioPortfolio";
import {PortalPortfolioAdd, PortalPortfolioAddMode} from "../../../shared/models/PortalPortfolioAdd";
import {PortalUrlConverter} from "../../../shared/models/PortalUrlConverter";
import {PortalUrlConverterPage} from "../../../shared/models/PortalUrlConverterPage";
import {CurrencyType, SwissQrCodeForm} from "../../../shared/models/SwissQrCodeForm";
import {PortalToolboxScaleScale} from "../../../shared/models/PortalToolboxScaleScale";
import FormatEnum from "../../../shared/models/FormatEnum";
import OrientationEnum from "../../../shared/models/OrientationEnum";
import PageMode from "../../../shared/models/PageMode";
import LengthUnit from "../../../shared/units/LengthUnit";
import {PortalSignature} from "../../../shared/models/PortalSignature";
import {PortalRubberStampAnnotation} from "../../../shared/models/PortalRubberStampAnnotation";
import {PortalToolboxAnnotationAnnotation} from "../../../shared/models/PortalToolboxAnnotationAnnotation";
import FunctionHelper from "../../../shared/helper/FunctionHelper";
import {PortalRedactAnnotation} from "../../../shared/models/PortalRedactAnnotation";
import {PortalAddToolboxAnnotation} from "../../../shared/models/PortalAddToolboxAnnotation";
import {HeaderFooterAlignment} from "../../../shared/models/PortalConverterHeaderFooter";
import {PortalConverterHtml} from "../../../shared/models/PortalConverterHtml";
import {AddressType} from "../../../shared/models/SwissQrCodeFormAddress";

class PortalDialogDefault {
	private _parameter: Map<PortalDialogType, DefaultParameters<any>>;
	private static _instance: PortalDialogDefault;
	private defaultParameters: Map<PortalDialogType, DefaultParameters<any>>;

	private constructor() {
		this.defaultParameters = new Map<PortalDialogType, DefaultParameters<any>>();
		this._parameter = new Map<PortalDialogType, DefaultParameters<any>>([
			[
				PortalDialogType.ROTATE,
				new DefaultParameters([
					new Parameter(
						ToolboxRotateRotate.fromJson({
							degrees: 90,
							pageGroup: PageGroup.All,
							pageOrientation: PageOrientation.Any,
							pages: '1',
							orientationDetectMode: OrientationDetection.Value
						} as ToolboxRotateRotate),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ORIENTATION,
				new DefaultParameters([
					new Parameter(
						ToolboxRotateRotate.fromJson({
							degrees: 270,
							pageGroup: PageGroup.All,
							pageOrientation: PageOrientation.Landscape,
							pages: '*',
							orientationDetectMode: OrientationDetection.Value
						} as ToolboxRotateRotate),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.CONVERT,
				new DefaultParameters([
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							dpi: 300,
							sharePointBridge: {},
							officeBridge: {},
							image: {
								maintainAspectRatio: true
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: FormatEnum.ORIGINAL,
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL,
								unit: LengthUnit.MILLIMETER,
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [
							MimeTypes.HEIC, MimeTypes.HEIC_SEQUENCE, MimeTypes.HEIF, MimeTypes.HEIF_SEQUENCE
						])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							dpi: 300,
							sharePointBridge: {},
							officeBridge: {},
							image: {
								maintainAspectRatio: true
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: FormatEnum.ORIGINAL,
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], []),
						new FileTypeGroupFilter([], [FileTypeGroup.IMAGE])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: true,
							dpi: 300,
							accessPassword: "",
							sharePointBridge: {},
							officeBridge: {},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: FormatEnum.ORIGINAL,
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.OFFICE, FileTypeGroup.WORD])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							dpi: 300,
							sharePointBridge: {},
							officeBridge: {},
							template: {
								language: TransformationSystemLanguage
							},
							image: {
								maintainAspectRatio: true
							},
							mail: {
								attachmentMode: AttachmentMode.Embed,
								adjustFonts: false,
								downloadImages: false,
								useBackground: true,
								resizeImages: false,
								resizeTables: false
							},
							header: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							footer: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: "A4",
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL,
								footer: {
									value: ""
								},
								header: {
									value: ""
								}
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.MAIL])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							conversionAsHTML: true,
							fileExtension: "html",
							sharePointBridge: {},
							officeBridge: {},
							text: {
								syntaxHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System,
									language: "xml",
									fontFamily: "",
									available: "xml",
									relevance: 90
								},
								textHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									fontFamily: "",
									color: "#000000",
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System
								},
								useSyntaxDetection: true
							},
							html: {
								baseURL: "",
								adjustFonts: false,
								downloadImages: false,
								useBackground: true,
								useAsTemplate: false,
								templateData: {
									source: FileDataSource.Value,
									value: ""
								},
								useTemplateFile: true,
								templateContent: "",
								errorReport: {
									format: ConverterHtmlErrorReportFormat.Json,
									mode: ConverterHtmlErrorReportMode.None
								}
							} as PortalConverterHtml,
							header: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							footer: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: "A4",
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL,
								footer: {
									value: ""
								},
								header: {
									value: ""
								}
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [MimeTypes.HTML])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							xmlMode: XmlMode.TEXT,
							xslTransformation: false,
							xRechnung: false,
							xRechnungOverwrite: false,
							sharePointBridge: {},
							officeBridge: {},
							transform: {
								xRechnung: {
									visualization: {
										file: [] as Array<XslTransformationFile>
									}
								},
								xslTransformation: {
									resources: {
										file: [] as Array<XslTransformationFile>
									}
								}
							},
							text: {
								syntaxHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System,
									language: "xml",
									fontFamily: "",
									available: "xml",
									relevance: 90
								},
								textHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									fontFamily: "",
									color: "#000000",
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System
								},
								useSyntaxDetection: true
							},
							header: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							footer: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: "A4",
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL,
								footer: {
									value: ""
								},
								header: {
									value: ""
								}
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [MimeTypes.XML, MimeTypes.APPXML, MimeTypes.APPXSLTXML])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: false,
							sharePointBridge: {},
							officeBridge: {},
							text: {
								syntaxHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System,
									language: "xml",
									fontFamily: "",
									available: "xml",
									relevance: 90
								},
								textHighlight: {
									fontSize: "10px",
									lineHeight: "12px",
									lineNumbers: true,
									fontFamily: "",
									color: "#000000",
									wordBreak: TextWrapMode.Auto,
									fontOrigin: FontOriginMode.System
								},
								useSyntaxDetection: true
							},
							header: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							footer: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: "A4",
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL,
								footer: {
									value: ""
								},
								header: {
									value: ""
								}
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter(
							[MimeTypes.XML, MimeTypes.APPXML, MimeTypes.APPXSLTXML], [MimeTypes.ALL]
						),
						new FileTypeGroupFilter([], [FileTypeGroup.TEXT])
					),
					new Parameter(
						PortalConverter.fromJson({
							converterType: ConverterType.OUTSIDEIN,
							embedFonts: false,
							jpegQuality: 100,
							pages: PAGERANGE_ALL,
							archive: false,
							reduceResolution: true,
							dpi: 300,
							sharePointBridge: {},
							officeBridge: {},
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							page: {
								format: "A4",
								top: 20,
								bottom: 20,
								left: 20,
								right: 20,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
								orientation: OrientationEnum.VERTICAL
							} as PortalPage
						} as PortalConverter),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.RENAME,
				new DefaultParameters([
					new Parameter(
						PortalRename.fromJson({
							fileName: ""
						} as PortalRename),
						new MimeTypeFilter([], [
							MimeTypes.ALL
						])
					)
				])
			],
			[
				PortalDialogType.PRINT,
				new DefaultParameters([
					new Parameter(
						ToolboxPrintPrint.fromJson({
							printerName: "",
							copies: 1,
							autoRotate: false,
							centerInPage: false,
							shrinkToMargins: false,
							expandToMargins: false,
							pages: PAGERANGE_ALL,
							dpi: 0,
							mode: PrintMode.Default
						} as ToolboxPrintPrint),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.DELETE_PAGE,
				new DefaultParameters([
					new Parameter(
						ToolboxDeleteDelete.fromJson({
							pages: PAGERANGE_ALL
						} as ToolboxDeleteDelete),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.SPLIT,
				new DefaultParameters([
					new Parameter(
						ToolboxSplitSplit.fromJson({
							pages: PAGERANGE_ALL,
							mode: SplitMode.List,
							startPage: 1
						} as ToolboxSplitSplit),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.WATERMARK,
				new DefaultParameters([
					new Parameter(
						PortalToolboxWatermarkWatermark.fromJson({
							mode: WatermarkMode.TEXT,
							pages: PAGERANGE_ALL,
							angle: 45,
							image: {
								opacity: 25,
								scale: 100,
								position: {
									aspectRatio: false,
									height: 0,
									width: 0,
									x: 0,
									y: 0,
									metrics: Metrics.Mm,
									position: WatermarkPositionMode.CenterCenter
								},
								data: {
									value: "",
									mimetype: "",
									name: ""
								} as PortalWatermarkFileData
							},
							text: {
								text: "",
								font: {
									color: "#888888",
									name: "Arial",
									opacity: 20,
									size: 24
								},
								position: {
									aspectRatio: false,
									height: 0,
									width: 0,
									x: 0,
									y: 0,
									metrics: Metrics.Mm,
									position: WatermarkPositionMode.CenterCenter
								}
							}
						} as PortalToolboxWatermarkWatermark),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_ADD_GLOBAL,
				new DefaultParameters([
					new Parameter(
						ToolboxAttachmentAttachment.fromJson({
							add: {
								file: [
									{
										fileName: "",
										mimeType: "",
										data: {
											value: ""
										}
									}
								] as Array<FileAttachment>
							}
						} as ToolboxAttachmentAttachment),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_ADD,
				new DefaultParameters([
					new Parameter(
						ToolboxAttachmentAttachment.fromJson({
							add: {
								file: [
									{
										creator: "",
										fileName: "",
										mimeType: "",
										data: {
											value: ""
										},
										annotation: {
											icon: Icons.Paperclip,
											color: "#4055FF",
											lockedPosition: false,
											page: 1,
											opacity: 100,
											popupText: "",
											point: {
												x: 0,
												y: 0,
												metrics: Metrics.Mm
											}
										}
									}
								] as Array<FileAttachment>
							}
						} as ToolboxAttachmentAttachment),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_EXTRACT,
				new DefaultParameters([
					new Parameter(
						ToolboxAttachmentAttachment.fromJson({
							extract: {
								selection: [] as Array<SelectionAttachment>,
								singleFileAsZip: false
							}
						} as ToolboxAttachmentAttachment),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_DELETE,
				new DefaultParameters([
					new Parameter(
						ToolboxAttachmentAttachment.fromJson({
							remove: {
								selection: [] as Array<SelectionAttachment>
							}
						} as ToolboxAttachmentAttachment),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_CONTENT,
				new DefaultParameters([
					new Parameter(
						PortalToolboxExtractionExtraction.fromJson({
							mode: ExtractionMode.TEXT,
							text: {
								fileFormat: ExtractionFileFormat.Xml,
								pages: PAGERANGE_ALL
							},
							words: {
								delimitAfterPunctuation: true,
								extendedSequenceCharacters: true,
								removePunctuation: false,
								fileFormat: ExtractionFileFormat.Xml,
								pages: PAGERANGE_ALL
							},
							links: {
								fileFormat: ExtractionFileFormat.Xml,
								text: {
									fromText: false
								},
								pages: PAGERANGE_ALL
							},
							images: {
								fileFormat: ExtractionFileFormat.Zip,
								fallbackFormat: ExtractionImageFormat.Png,
								fileNameTemplate: "file[%d]",
								folderNameTemplate: "page[%d]",
								pages: PAGERANGE_ALL
							}
						} as PortalToolboxExtractionExtraction),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_IMAGES,
				new DefaultParameters([
					new Parameter(
						PortalToolboxImageImage.fromJson({
							format: ImageFormat.JPEG,
							jpeg: {
								dpi: 72,
								height: 0,
								width: 0,
								jpegQuality: 80,
								metrics: Metrics.Mm
							},
							png: {
								dpi: 72,
								height: 0,
								width: 0,
								metrics: Metrics.Mm
							},
							gif: {
								dpi: 72,
								height: 0,
								width: 0,
								metrics: Metrics.Mm
							},
							tiff: {
								dpi: 72,
								height: 0,
								width: 0,
								compression: TiffCompression.None,
								jpegQuality: 80,
								multipage: false,
								metrics: Metrics.Mm
							},
							bmp: {
								dpi: 72,
								height: 0,
								width: 0,
								metrics: Metrics.Mm
							},
							svg: {
								dpi: 72,
								height: 0,
								width: 0,
								metrics: Metrics.Mm,
								graphicsStateMode: SvgGraphicsStateMode.Centralize,
								pathDrawMode: SvgPathDrawMode.Compact
							},
							pages: PAGERANGE_ALL
						} as PortalToolboxImageImage),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_INFO,
				new DefaultParameters([
					new Parameter(
						PortalToolboxExtractionExtraction.fromJson({
							info: {
								fileFormat: ExtractionFileFormat.Xml
							}
						} as PortalToolboxExtractionExtraction),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_PAGE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxSplitSplit.fromJson({
							mode: SplitMode.Single,
							deleteSource: false,
							pages: PAGERANGE_ALL,
							pageNumber: 2,
							startPage: 1,
							singleFileAsZip: false
						} as PortalToolboxSplitSplit),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BACKGROUND,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOptionsOptions.fromJson({
							background: {
								mode: BackgroundFunction.ADD,
								remove: {
									backgroundSelection: {}
								},
								add: {
									mode: BackgroundMode.COLOR,
									colorBackground: {
										color: '#ffffff',
										settings: {
											scale: 50,
											rotation: 0,
											relativeToPage: false,
											replaceExisting: true,
											opacity: 75,
											visibility: {
												onPrint: true,
												onScreen: true
											},
											pages: {
												from: 1,
												to: 1,
												mode: PageMode.All,
												pageInterval: {
													pages: PAGERANGE_ALL,
													odd: true,
													even: true
												}
											} as PortalPagesBackgroundBaseSettings,
											position: {
												position: BackgroundPositionMode.CenterCenter,
												metrics: Metrics.Mm,
												x: 0,
												y: 0
											}
										} as PortalBackgroundBaseSettings
									} as PortalColorBackground,
									imageBackground: {
										image: {
											value: "",
											name: "",
											mimetype: ""
										} as PortalBackgroundFileData,
										settings: {
											scale: 50,
											rotation: 0,
											relativeToPage: false,
											replaceExisting: true,
											opacity: 75,
											visibility: {
												onPrint: true,
												onScreen: true
											},
											pages: {
												from: 1,
												to: 1,
												mode: PageMode.All,
												pageInterval: {
													pages: PAGERANGE_ALL,
													odd: true,
													even: true
												}
											} as PortalPagesBackgroundBaseSettings,
											position: {
												position: BackgroundPositionMode.CenterCenter,
												metrics: Metrics.Mm,
												x: 0,
												y: 0
											}
										} as PortalBackgroundBaseSettings
									} as PortalImageBackground
								} as PortalAddBackground
							} as PortalBackgroundToolboxOptions
						} as PortalToolboxOptionsOptions),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.HEADER_FOOTER,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOptionsOptions.fromJson({
							headerFooter: {
								mode: HeaderFooterFunction.ADD,
								remove: {
									headerFooterSelection: {}
								},
								add: {
									headerFooterContent: {
										pages: {
											from: 1,
											to: 1,
											mode: PageMode.All,
											pageInterval: {
												pages: PAGERANGE_ALL,
												odd: true,
												even: true
											}
										} as PortalPagesHeaderFooter,
										firstPageNumber: 1,
										font: {
											name: "Arial",
											size: 10,
											underline: false,
											color: "#000000"
										},
										footer: {
											centerOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											},
											leftOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											},
											rightOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											}
										} as PortalHeaderFooterPositions,
										header: {
											centerOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											},
											leftOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											},
											rightOptions: {
												type: PositionsOptionsType.NONE,
												custom: "",
												date: OptionsTypeDate["M/D"],
												page: "i",
												batesDigits: 6,
												batesPrefix: "",
												batesSuffix: ""
											}
										} as PortalHeaderFooterPositions,
										margin: {
											left: 0,
											right: 0,
											top: 0,
											bottom: 0,
											metrics: Metrics.Mm
										},
										replaceExisting: true
									}
								}
							} as PortalHeaderFooterToolboxOptions
						} as PortalToolboxOptionsOptions),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.DESCRIPTION,
				new DefaultParameters([
					new Parameter(
						ToolboxDescriptionDescription.fromJson({
							title: "",
							author: "",
							subject: "",
							keywords: "",
							producer: "webPDF (https://www.webpdf.de)",
							creator: "webPDF Portal",
							custom: [] as Array<DescriptionCustom>
						} as ToolboxDescriptionDescription),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.VIEW,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOptionsOptions.fromJson({
							pageLayout: PageLayout.SinglePage,
							initialView: InitialView.None,
							magnification: Magnification.None,
							magnificationZoom: 100,
							initialPage: 1,
							viewerPreferences: {
								hideToolbar: false,
								hideMenuBar: false,
								hideWindowUI: false,
								fitWindow: false,
								centerWindow: false,
								displayDocTitle: false,
								nonFullScreenPageMode: NonFullScreenPageMode.None,
								textDirection: TextDirection.LeftToRight,
								viewArea: PageBox.CropBox,
								viewClip: PageBox.CropBox,
								printArea: PageBox.CropBox,
								printClip: PageBox.CropBox,
								printScaling: PrintScale.ReaderDefault,
								duplex: Duplex.None,
								printTraySelection: PrintTraySelection.ReaderDefault,
								printPageRange: PAGERANGE_ALL,
								numCopies: 1
							}
						} as PortalToolboxOptionsOptions),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BOXES,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOptionsOptions.fromJson({
							boxes: {
								mode: BoxesFunction.EDIT,
								type: PageBox.MediaBox,
								remove: [] as Array<RemoveBoxes>,
								resize: [
									{
										boxesResize: {
											box: PageBox.ArtBox,
											dimensions: {
												metrics: Metrics.Mm,
												height: 0,
												width: 0,
												x: 0,
												y: 0
											},
											pages: PAGERANGE_ALL
										}
									},
									{
										boxesResize: {
											box: PageBox.TrimBox,
											dimensions: {
												metrics: Metrics.Mm,
												height: 0,
												width: 0,
												x: 0,
												y: 0
											},
											pages: PAGERANGE_ALL
										}
									},
									{
										boxesResize: {
											box: PageBox.BleedBox,
											dimensions: {
												metrics: Metrics.Mm,
												height: 0,
												width: 0,
												x: 0,
												y: 0
											},
											pages: PAGERANGE_ALL
										}
									},
									{
										boxesResize: {
											box: PageBox.CropBox,
											dimensions: {
												metrics: Metrics.Mm,
												height: 0,
												width: 0,
												x: 0,
												y: 0
											},
											pages: PAGERANGE_ALL
										}
									},
									{
										boxesResize: {
											box: PageBox.MediaBox,
											dimensions: {
												metrics: Metrics.Mm,
												height: 0,
												width: 0,
												x: 0,
												y: 0
											},
											pages: PAGERANGE_ALL
										}
									}
								]
							} as PortalBoxesToolboxOptions
						} as PortalToolboxOptionsOptions),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.TRANSITION,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOptionsOptions.fromJson({
							pageTransitions: {
								remove: [] as Array<RemovePageTransitions>,
								add: [
									{
										pageTransition: {
											autoScroll: true,
											autoScrollTime: 1,
											duration: 1,
											style: TransitionStyle.Blinds,
											direction: TransitionDirection.LeftToRight,
											flyScale: 100,
											flyAreaOpaque: true,
											pages: PAGERANGE_ALL
										}
									}
								]
							}
						} as PortalToolboxOptionsOptions),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ADD_PAGE,
				new DefaultParameters([
					new Parameter(
						PortalPagesAdd.fromJson({
							data: {
								format: FileDataFormat.Id,
								value: ""
							},
							addMode: PagesAddModeEnum.AtTheEnd,
							page: 1,
							resetMetadata: false,
							sourceIsZip: false
						} as PortalPagesAdd),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.PDFA,
				new DefaultParameters([
					new Parameter(
						PortalPdfa.fromJson({
							mode: PdfaMode.ANALYZE,
							analyze: {
								level: PdfaLevel._3b
							},
							convert: {
								level: PdfaLevel._3b,
								imageQuality: 75,
								errorReport: PdfaErrorReport.File,
								autoTagging: true,
								errorCorrection: {
									enabled: false
								},
								zugferd: {
									xmlFile: {
										version: ZugferdVersion.V10Comfort,
										name: "",
										mimetype: "",
										value: ""
									} as PortalZugferdFileData
								}
							}
						} as PortalPdfa),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.OCR,
				new DefaultParameters([
					new Parameter(
						PortalOcr.fromJson({
							checkResolution: false,
							failOnWarning: false,
							imageDpiActive: false,
							imageDpi: 200,
							language: OcrLanguage.Eng,
							outputFormat: OcrOutput.Pdf,
							normalizePageRotation: false,
							jpegQuality: 75,
							optimizationActive: false,
							optimization: {
								deskew: true,
								despeckle: true,
								reduceDithering: false,
								noiseReduction: OptimizationIntensity.Low,
								gammaCorrection: OptimizationIntensity.Off,
								increaseContrast: OptimizationIntensity.Off,
								edgeAccentuation: OptimizationIntensity.Low,
								sharpen: OptimizationIntensity.Low,
								medianFilter: OptimizationIntensity.Medium
							},
							page: {
								format: FormatEnum.ORIGINAL,
								orientation: OrientationEnum.VERTICAL,
								width: 210,
								height: 297,
								metrics: Metrics.Mm,
							} as PortalOcrPage,
							pdfaMode: OcrPdfaType.NONE,
							pdfa: {
								convert: {
									level: PdfaLevel._3b,
									imageQuality: 75
								}
							},
							forceEachPage: false
						} as PortalOcr),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SIGNATURE,
				new DefaultParameters([
					new Parameter(
						PortalSignature.fromJson({
							add: {
								newName: "",
								fieldName: "",
								keyName: "",
								contact: "",
								location: "",
								reason: "",
								appendSignature: true,
								appearance: {
									showCommonName: true,
									identifier: "",
									name: "",
									page: 1,
									identifierElements: {
										textSignedBy: "",
										showCommonName: false,
										showCountry: false,
										showDate: false,
										showLocal: false,
										showMail: false,
										showName: false,
										showOrganisationName: false,
										showOrganisationUnit: false,
										showSignedBy: false,
										showState: false
									},
									image: {
										opacity: 100,
										position: SignatureImagePosition.Left,
										data: {
											name: "",
											mimetype: "",
											value: ""
										} as PortalSignatureFileData
									},
									position: {
										height: 0,
										width: 0,
										x: 0,
										y: 0,
										metrics: Metrics.Mm
									}
								},
								certificationLevel: CertificationLevel.None,
								visible: false,
								signer: {
									keyPair: {
										certificate: {
											value: "",
											source: FileDataSource.Value
										},
										privateKey: {
											value: "",
											source: FileDataSource.Value,
											password: ""
										}
									}
								}
							} as PortalAddSignature
						} as PortalSignature),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SIGNATURE_REMOVE,
				new DefaultParameters([
					new Parameter(
						Signature.fromJson({
							clear: {
								flatten: false
							}
						} as Signature),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.FLATTEN_FORMS,
				new DefaultParameters([
					new Parameter(
						ToolboxFormsForms.fromJson({
							flatten: {}
						} as ToolboxFormsForms),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_FORMS,
				new DefaultParameters([
					new Parameter(
						ToolboxFormsForms.fromJson({
							export: {
								format: FormsFormat.Xml,
								fdfFileName: ""
							} as FormsExport
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.IMPORT_FORMS,
				new DefaultParameters([
					new Parameter(
						ToolboxFormsForms.fromJson({
							import: {
								data: {
									name: "",
									mimetype: "",
									value: ""
								} as PortalFormsFileData,
								format: FormsFormat.Xml,
								flatten: false
							} as FormsImport
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EDIT_FORMS,
				new DefaultParameters([
					new Parameter(
						ToolboxFormsForms.fromJson({
							import: {
								data: {
									name: "data.xml",
									mimetype: MimeTypes.XML.toString(),
									value: ""
								} as PortalFormsFileData,
								format: FormsFormat.Xml,
								flatten: false
							} as FormsImport
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.SANITIZE,
				new DefaultParameters([
					new Parameter(
						ToolboxRedactRedact.fromJson({
							sanitize: {
								annotations: {
									enabled: true
								},
								attachments: {
									enabled: true
								},
								forms: {
									enabled: true
								},
								layers: {
									enabled: true
								},
								metadata: {
									enabled: true
								},
								outlines: {
									enabled: true
								},
								tags: {
									enabled: true
								},
								actions: {
									enabled: true
								},
								pages: {
									dpi: 72,
									enabled: true,
									pages: PAGERANGE_ALL
								}
							}
						} as ToolboxRedactRedact),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REDACT_PAGE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxAnnotationAnnotation.fromJson({
							add: {
								redact: [
									{
										contents: "",
										interiorColor: "#000000",
										creator: "",
										subject: "",
										intents: "",
										opacity: 100,
										page: 1,
										color: "#FF0000",
										position: {
											pathElement: [
												{
													width: 0,
													height: 0,
													x: 0,
													y: 0,
													metrics: Metrics.Mm
												}
											]
										},
										apply: true
									} as PortalRedactAnnotation
								]
							} as PortalAddToolboxAnnotation
						} as PortalToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REDACT_AREA,
				new DefaultParameters([
					new Parameter(
						PortalToolboxAnnotationAnnotation.fromJson({
							add: {
								redact: [
									{
										contents: "",
										interiorColor: "#000000",
										creator: "",
										subject: "",
										intents: "",
										opacity: 100,
										page: 1,
										color: "#FF0000",
										position: {
											pathElement: [
												{
													width: 0,
													height: 0,
													x: 0,
													y: 0,
													metrics: Metrics.Mm
												}
											]
										},
										apply: true
									} as PortalRedactAnnotation
								]
							} as PortalAddToolboxAnnotation
						} as PortalToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REDACT_TEXT,
				new DefaultParameters([
					new Parameter(
						PortalToolboxAnnotationAnnotation.fromJson({
							add: {
								redact: [
									{
										contents: "",
										interiorColor: "#000000",
										creator: "",
										subject: "",
										intents: "",
										opacity: 100,
										page: 1,
										color: "#FF0000",
										position: {
											pathElement: [] as Array<Rectangle>
										},
										apply: true
									} as PortalRedactAnnotation
								]
							} as PortalAddToolboxAnnotation
						} as PortalToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REDACT,
				new DefaultParameters([
					new Parameter(
						ToolboxRedactRedact.fromJson({
							blacken: {
								collisionRatio: 30,
								redactAnnotations: true,
								redactImages: true,
								redactPaths: true,
								redactTexts: true
							}
						} as ToolboxRedactRedact),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REDACT_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								redact: {
									contents: "",
									interiorColor: "#000000",
									creator: "",
									subject: "",
									intents: "",
									opacity: 100,
									page: 1,
									color: "#FF0000",
									position: {
										pathElement: [] as Array<Rectangle>
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ADD_OUTLINE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOutlineOutline.fromJson({
							add: {
								item: [
									{
										actions: [] as Array<PortalActionEvent>,
										color: "#000000",
										bold: false,
										isOpen: false,
										italic: false,
										itemName: "",
										path: PATH_SEPARATOR,
										position: PortalItemPosition.End
									} as PortalItem
								] as Array<PortalItem>
							} as PortalAddToolboxOutline
						} as PortalToolboxOutlineOutline),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.REMOVE_OUTLINE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxOutlineOutline.fromJson({
							remove: {
								item: [] as Array<ItemReference>
							}
						} as PortalToolboxOutlineOutline),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_SWISS_QR,
				new DefaultParameters([
					new Parameter(
						PortalBarcode.fromJson({
							add: {
								format: PortalBarcodeFormat.swissqrcode,
								outputFormat: BarcodeCreateOutputFormat.Pdf,
								qrswiss: [
									{
										dpi: 200,
										format: QrSwissPaymentFormat.BillOnly,
										content: {
											value: JSON.stringify({
												"account": "",
												"creditor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"amount": 0,
												"currency": "EUR",
												"debtor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"reference": "",
												"unstructuredMessage": ""
											}),
											format: QrSwissPaymentContentFormat.Json,
											source: FileDataSource.Value
										},
										pdf: {
											mode: QrSwissPaymentPdfMode.InsertBefore,
											page: 1
										},
										language: QrSwissPaymentLanguage.De,
										separator: QrSwissPaymentSeparator.None
									}
								] as Array<QrSwissPaymentBarcode>
							} as PortalAddBarcode
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_SWISS_QR_AREA,
				new DefaultParameters([
					new Parameter(
						PortalBarcode.fromJson({
							add: {
								format: PortalBarcodeFormat.swissqrcode,
								outputFormat: BarcodeCreateOutputFormat.Pdf,
								qrswiss: [
									{
										dpi: 200,
										format: QrSwissPaymentFormat.CodeOnly,
										position: {
											x: 0,
											y: 0,
											metrics: Metrics.Mm
										},
										content: {
											value: JSON.stringify({
												"account": "",
												"creditor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"amount": 0,
												"currency": "EUR",
												"debtor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"reference": "",
												"unstructuredMessage": ""
											}),
											format: QrSwissPaymentContentFormat.Json,
											source: FileDataSource.Value
										},
										pdf: {
											mode: QrSwissPaymentPdfMode.AddToPage,
											page: 1
										},
										language: QrSwissPaymentLanguage.De,
										separator: QrSwissPaymentSeparator.None,
									}
								] as Array<QrSwissPaymentBarcode>
							} as PortalAddBarcode
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE,
				new DefaultParameters([
					new Parameter(
						PortalBarcode.fromJson({
							add: {
								format: PortalBarcodeFormat.qrcode,
								outputFormat: BarcodeCreateOutputFormat.Pdf,
								unit: LengthUnit.MILLIMETER,
								qrcode: [
									{
										value: "https://www.webpdf.de",
										errorCorrection: QrCodeErrorCorrection.L,
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<QrBarcode>,
								qrswiss: [
									{
										dpi: 200,
										format: QrSwissPaymentFormat.CodeOnly,
										content: {
											value: JSON.stringify({
												"account": "",
												"creditor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"amount": 0,
												"currency": "EUR",
												"debtor": {
													"type": "S",
													"name": "",
													"addressLine1": "",
													"addressLine2": "",
													"street": "",
													"houseNo": "",
													"postalCode": "",
													"town": "",
													"countryCode": ""
												},
												"reference": "",
												"unstructuredMessage": ""
											}),
											format: QrSwissPaymentContentFormat.Json,
											source: FileDataSource.Value
										},
										pdf: {
											mode: QrSwissPaymentPdfMode.AddToPage,
											page: 1
										},
										language: QrSwissPaymentLanguage.De,
										separator: QrSwissPaymentSeparator.None
									}
								] as Array<QrSwissPaymentBarcode>,
								aztec: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										errorCorrection: 7,
										layers: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<AztecBarcode>,
								codabar: [
									{
										value: "A1234567890A",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 44,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<CodabarBarcode>,
								code39: [
									{
										value: "WEBPDF.DE",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 51,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Code39Barcode>,
								code128: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 95,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Code128Barcode>,
								datamatrix: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										errorCorrection: 2,
										shape: DataMatrixShape.Default,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<DataMatrixBarcode>,
								ean8: [
									{
										value: "12345670",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 25,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Ean8Barcode>,
								ean13: [
									{
										value: "4012345123456",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 35,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Ean13Barcode>,
								itf: [
									{
										value: "12345678901231",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 49,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<ItfBarcode>,
								pdf417: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										compact: false,
										compactionMode: Pdf417CompactionMode.Auto,
										dimensions: false,
										dataCodewordsMax: 4,
										dataCodewordsMin: 1,
										symbolsPerCodewordMax: 7,
										symbolsPerCodewordMin: 1,
										errorCorrection: 2,
										shape: DataMatrixShape.Default,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 51,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<PortalPdf417Barcode>,
								upca: [
									{
										value: "722527273070",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 35,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<UpcaBarcode>,
							} as PortalAddBarcode
						}),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_AREA,
				new DefaultParameters([
					new Parameter(
						PortalBarcode.fromJson({
							add: {
								format: PortalBarcodeFormat.qrcode,
								outputFormat: BarcodeCreateOutputFormat.Pdf,
								qrcode: [
									{
										value: "https://www.webpdf.de",
										errorCorrection: QrCodeErrorCorrection.L,
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<QrBarcode>,
								aztec: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										},
										errorCorrection: 7,
										layers: 0
									}
								] as Array<AztecBarcode>,
								codabar: [
									{
										value: "A1234567890A",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 50,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<CodabarBarcode>,
								code39: [
									{
										value: "WWW.WEBPDF.DE",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 60,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Code39Barcode>,
								code128: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 110,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Code128Barcode>,
								datamatrix: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 20,
											height: 20,
											metrics: Metrics.Mm
										},
										errorCorrection: 2,
										shape: DataMatrixShape.Default
									}
								] as Array<DataMatrixBarcode>,
								ean8: [
									{
										value: "12345670",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 30,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Ean8Barcode>,
								ean13: [
									{
										value: "4012345123456",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 40,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<Ean13Barcode>,
								itf: [
									{
										value: "12345678901231",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 55,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<ItfBarcode>,
								pdf417: [
									{
										value: "https://www.webpdf.de",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 60,
											height: 20,
											metrics: Metrics.Mm
										},
										compact: false,
										compactionMode: Pdf417CompactionMode.Auto,
										dimensions: false,
										dataCodewordsMax: 4,
										dataCodewordsMin: 1,
										symbolsPerCodewordMax: 7,
										symbolsPerCodewordMin: 1,
										errorCorrection: 2,
										shape: DataMatrixShape.Default
									}
								] as Array<PortalPdf417Barcode>,
								upca: [
									{
										value: "722527273070",
										margin: 3,
										rotation: 0,
										pages: PAGERANGE_ALL,
										position: {
											x: 0,
											y: 0,
											width: 40,
											height: 20,
											metrics: Metrics.Mm
										}
									}
								] as Array<UpcaBarcode>,
							} as PortalAddBarcode
						}),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.BARCODE_DETECT,
				new DefaultParameters([
					new Parameter(
						PortalBarcode.fromJson({
							detect: {
								inputFormat: BarcodeDetectInputFormat.Pdf,
								outputFormat: BarcodeDetectOutputFormat.Xml,
								selection: [
									{
										formats:
											"qrcode,aztec,codabar,code128,code39,datamatrix,ean13,ean8,itf,pdf417,upca",
										pureBarcode: false,
										tryHarder: true,
										pages: PAGERANGE_ALL,
										gs1: false,
										scanArea: {
											metrics: Metrics.Mm,
											x: 0,
											y: 0,
											width: 0,
											height: 0
										},
										barcode39CheckDigit: false,
										codabarStartEndDigits: false,
										upcEanExtensions: "0",
										allowedLengths: "0"
									}
								] as Array<BarcodeSelection>
							}
						} as PortalBarcode),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_NOTE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								text: [
									{
										page: 1,
										subject: "",
										creator: "",
										opacity: 100,
										color: "#00FF00",
										contents: "",
										intents: "",
										icon: TextAnnotationIcons.Comment,
										initialOpen: false,
										normalAppearance: {
											svg: {
												aspectRatioAxis: Axis.Y,
												preserveAspectRatio: true,
												data: {
													source: FileDataSource.Value,
													value: ""
												}
											}
										},
										position: {
											x: 0,
											y: 0,
											width: 8,
											height: 8,
											metrics: Metrics.Mm
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_NOTE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								text: {
									page: 1,
									subject: "",
									creator: "",
									opacity: 100,
									color: "#00FF00",
									contents: "",
									intents: "",
									icon: TextAnnotationIcons.Comment,
									initialOpen: false,
									position: {
										x: 0,
										y: 0,
										width: 8,
										height: 8,
										metrics: Metrics.Mm
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_MARK,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								markup: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#FFFF00",
										markupType: MarkupsAnnotation.Highlight,
										position: {
											pathElement: [] as Array<Rectangle>
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_MARK_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								markup: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#FF0000",
									markupType: MarkupsAnnotation.Highlight,
									position: {
										pathElement: [] as Array<Rectangle>
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_UNDERLINE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								markup: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#00FF00",
										markupType: MarkupsAnnotation.Underline,
										position: {
											pathElement: [] as Array<Rectangle>
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_UNDERLINE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								markup: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#00FF00",
									markupType: MarkupsAnnotation.Underline,
									position: {
										pathElement: [] as Array<Rectangle>
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUIGGLY,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								markup: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#008080",
										markupType: MarkupsAnnotation.Squiggly,
										position: {
											pathElement: [] as Array<Rectangle>
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUIGGLY_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								markup: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#008080",
									markupType: MarkupsAnnotation.Squiggly,
									position: {
										pathElement: [] as Array<Rectangle>
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STRIKE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								markup: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#FF0000",
										markupType: MarkupsAnnotation.StrikeOut,
										position: {
											pathElement: [] as Array<Rectangle>
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STRIKE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								markup: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#FF0000",
									markupType: MarkupsAnnotation.StrikeOut,
									position: {
										pathElement: [] as Array<Rectangle>
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_DELETE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							remove: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_LINE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								line: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#000000",
										border: {
											borderWidth: 1,
											borderStyle: BorderStyle.Solid
										}
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_LINE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								line: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#000000",
									border: {
										borderWidth: 1,
										borderStyle: BorderStyle.Solid
									}
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUARE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								square: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#000000",
										interiorColor: "#FFFFFF",
										border: {
											borderWidth: 1,
											borderStyle: BorderStyle.Solid
										},
										drawMode: DrawMode.Stroke
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUARE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								square: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#000000",
									interiorColor: "#FFFFFF",
									border: {
										borderWidth: 1,
										borderStyle: BorderStyle.Solid
									},
									drawMode: DrawMode.Stroke
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_CIRCLE,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							add: {
								circle: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#000000",
										interiorColor: "#FFFFFF",
										border: {
											borderWidth: 1,
											borderStyle: BorderStyle.Solid
										},
										drawMode: DrawMode.Stroke
									}
								]
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_CIRCLE_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								circle: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100,
									color: "#000000",
									interiorColor: "#FFFFFF",
									border: {
										borderWidth: 1,
										borderStyle: BorderStyle.Solid
									},
									drawMode: DrawMode.Stroke
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.MERGE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxMergeMerge.fromJson({
							mode: MergeMode.AtTheEnd,
							operation: MergeOperation.atTheEnd,
							page: 1,
							resetMetadata: false,
							removeStaticXFA: false,
							sourceIsZip: false,
							archive: false,
							pdfa: {
								convert: {
									imageQuality: 75,
									level: PdfaLevel._3b
								}
							},
							data: {
								format: "id",
								value: ""
							}
						} as PortalToolboxMergeMerge),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_CREATE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxPortfolioPortfolio.fromJson({
							add: {
								fileName: "",
								file: [] as Array<PortfolioFile>,
								initialFile: false
							} as PortalPortfolioAdd
						} as PortalToolboxPortfolioPortfolio),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_ADD_FILE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxPortfolioPortfolio.fromJson({
							add: {
								fileName: "",
								mode: PortalPortfolioAddMode.FILES,
								file: [] as Array<PortfolioFile>,
								folder: [] as Array<PortfolioFolder>,
								initialFile: false
							} as PortalPortfolioAdd
						} as PortalToolboxPortfolioPortfolio),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_ADD_FOLDER,
				new DefaultParameters([
					new Parameter(
						PortalToolboxPortfolioPortfolio.fromJson({
							add: {
								fileName: "",
								mode: PortalPortfolioAddMode.FOLDER,
								file: [] as Array<PortfolioFile>,
								folder: [] as Array<PortfolioFolder>
							} as PortalPortfolioAdd
						} as PortalToolboxPortfolioPortfolio),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_REMOVE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxPortfolioPortfolio.fromJson({
							remove: {
								selection: [] as Array<PortfolioSelection>
							}
						} as PortalToolboxPortfolioPortfolio),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_EXTRACT,
				new DefaultParameters([
					new Parameter(
						PortalToolboxPortfolioPortfolio.fromJson({
							extract: {
								singleFileAsZip: false,
								selection: [] as Array<PortfolioSelection>
							}
						} as PortalToolboxPortfolioPortfolio),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ENCRYPT,
				new DefaultParameters([
					new Parameter(
						ToolboxSecuritySecurity.fromJson({
							encrypt: {
								canAssemble: false,
								canExtractContent: false,
								canExtractForAccessibility: false,
								canFillInForm: false,
								canModify: false,
								canModifyAnnotations: false,
								canPrint: false,
								canPrintHighRes: false,
								password: {
									open: "",
									permission: "",
									encryptionKey: PdfEncryptionKey.AES128
								},
								contentEncryption: PdfContentEncryption.EncryptEverything
							}
						} as ToolboxSecuritySecurity),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.CERTIFICATE_ENCRYPT,
				new DefaultParameters([
					new Parameter(
						ToolboxSecuritySecurity.fromJson({
							encryptCertificate: {
								encryptionKey: PdfEncryptionKey.AES128,
								recipient: [] as Array<Recipient>,
								contentEncryption: PdfContentEncryption.EncryptEverything
							}
						} as ToolboxSecuritySecurity),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.DECRYPT,
				new DefaultParameters([
					new Parameter(
						ToolboxSecuritySecurity.fromJson({
							decrypt: {}
						} as ToolboxSecuritySecurity),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.MOVE,
				new DefaultParameters([
					new Parameter(
						ToolboxMoveMove.fromJson({
							mode: MoveMode.BeforePage,
							targetPosition: 1,
							pages: PAGERANGE_ALL,
							order: Order.Preserve
						} as ToolboxMoveMove),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.URLCONVERTER,
				new DefaultParameters([
					new Parameter(
						PortalUrlConverter.fromJson({
							url: "https://www.webpdf.de",
							proxy: {},
							basicAuth: {
								userName: "",
								password: ""
							},
							page: {
								format: "A4",
								orientation: OrientationEnum.VERTICAL,
								right: 20,
								left: 20,
								bottom: 20,
								top: 20,
								width: 210,
								height: 287,
								metrics: Metrics.Mm,
								unit: LengthUnit.MILLIMETER,
								footer: {
									value: ""
								},
								header: {
									value: ""
								}
							} as PortalUrlConverterPage,
							header: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							},
							footer: {
								plain: true,
								color: "#000000",
								alignment: HeaderFooterAlignment.LEFT,
								fontFamily: "",
								fontSize: 10,
								content: "",
								margins: {
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									metrics: Metrics.Mm
								}
							}
						} as PortalUrlConverter),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_SWISS_QR_CODE_FORM,
				new DefaultParameters([
					new Parameter(
						SwissQrCodeForm.fromJson({
							account: "",
							creditor: {
								type: AddressType.STRUCTURED,
								name: "",
								street: "",
								houseNumber: "",
								postalCode: "",
								location: "",
								countryCode: "",
							},
							debtor: {
								type: AddressType.STRUCTURED,
								name: "",
								street: "",
								houseNumber: "",
								postalCode: "",
								location: "",
								countryCode: "",
							},
							amount: 0,
							currency: CurrencyType.EUR,
							reference: "",
							unstructuredMessage: ""
						} as SwissQrCodeForm),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.COMPRESS,
				new DefaultParameters([
					new Parameter(
						ToolboxCompressCompress.fromJson({
							compressObjects: {
								objectStreamSize: 200
							}
						} as ToolboxCompressCompress),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.SCALE,
				new DefaultParameters([
					new Parameter(
						PortalToolboxScaleScale.fromJson({
							format: "A4",
							orientation: OrientationEnum.VERTICAL,
							scalePages: {
								dimensions: {
									right: 0,
									left: 0,
									bottom: 0,
									top: 0,
									width: 210,
									height: 297,
									metrics: Metrics.Mm
								},
								verticalAlignment: "top",
								horizontalAlignment: "left",
								preserveAspectRatio: true,
								scaleBoxes: true,
								pages: PAGERANGE_ALL
							}
						} as PortalToolboxScaleScale),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_HTML,
				new DefaultParameters([
					new Parameter(
						ToolboxTranscribeTranscribe.fromJson({
							failureLevel: Failure.Error,
							errorReport: TranscribeErrorReport.File,
							successReport: TranscribeSuccessReport.None,
							html: {
								dpi: 72,
								pages: PAGERANGE_ALL
							}
						} as ToolboxTranscribeTranscribe),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_REPLY,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							comment: {
								add: {
									replyTo: [
										{
											page: 1,
											name: "",
											creator: "",
											subject: "",
											replyTo: "",
											comment: ""
										}
									] as Array<ReplyToAnnotation>
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_REPLY_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							comment: {
								edit: {
									replyTo: [
										{
											page: 1,
											name: "",
											creator: "",
											subject: "",
											comment: "",
											objectKey: {
												id: ""
											}
										}
									] as Array<ReplyToAnnotationEdit>
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STAMP,
				new DefaultParameters([
					new Parameter(
						PortalToolboxAnnotationAnnotation.fromJson({
							add: {
								rubberstamp: [
									{
										page: 1,
										subject: "",
										creator: "",
										intents: "",
										contents: "",
										opacity: 100,
										color: "#F0F0F0",
										borderColor: "#BBBBBB",
										fontColor: "#666666",
										fontSize: 26,
										icon: RubberStampIcon.Approved,
										normalAppearance: {
											svg: {
												aspectRatioAxis: Axis.X,
												preserveAspectRatio: true,
												data: {
													source: FileDataSource.Value,
													value: ""
												}
											}
										}
									}
								] as Array<PortalRubberStampAnnotation>
							}
						} as PortalToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STAMP_EDIT,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							edit: {
								selection: {
									select: [
										{
											page: 1
										}
									] as Array<SelectionAnnotation>
								},
								rubberstamp: {
									page: 1,
									subject: "",
									creator: "",
									intents: "",
									contents: "",
									opacity: 100
								}
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_FLATTEN,
				new DefaultParameters([
					new Parameter(
						ToolboxAnnotationAnnotation.fromJson({
							clear: {
								pages: PAGERANGE_ALL,
								flatten: true
							}
						} as ToolboxAnnotationAnnotation),
						new MimeTypeFilter([], [MimeTypes.PDF])
					)
				])
			],
			[
				PortalDialogType.SETTINGS_CERTIFICATE,
				new DefaultParameters([
					new Parameter(
						KeyStorePassword.fromJson({
							aliases: {}
						} as KeyStorePassword),
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			]
		]);
	}

	public setParameter<T_PARAMETER_TYPE extends ParameterType>(
		dialogType: PortalDialogType, parameter: Parameter<T_PARAMETER_TYPE>, selection: Array<PortalDocument>
	) {
		let currentParameter: Parameter<T_PARAMETER_TYPE> | undefined =
			this.defaultParameters.get(dialogType)?.get(selection);

		if (FunctionHelper.exists(currentParameter)) {
			currentParameter!.data = parameter.data;
		} else {
			if (!FunctionHelper.exists(this.defaultParameters.get(dialogType))) {
				this.defaultParameters.set(dialogType, new DefaultParameters<T_PARAMETER_TYPE>());
			}

			this.defaultParameters.get(dialogType)!.add(parameter);
		}
	}

	public getParameter<T_PARAMETER_TYPE extends ParameterType>(
		dialogType: PortalDialogType, selection: Array<PortalDocument>
	): Parameter<T_PARAMETER_TYPE> {
		let parameter: Parameter<T_PARAMETER_TYPE> | undefined =
			this.defaultParameters.get(dialogType)?.get(selection)?.clone();

		if (!FunctionHelper.exists(parameter)) {
			parameter = this._parameter.get(dialogType)?.get(selection)?.clone();
		}

		if (FunctionHelper.exists(parameter)) {
			return parameter!;
		}

		throw new Error("unknown parameter type");
	}

	get parameter(): Map<PortalDialogType, DefaultParameters<any>> {
		return this._parameter;
	}

	public static get instance(): PortalDialogDefault {
		return FunctionHelper.applyValue(
			this._instance, (this._instance = new this())
		);
	}
}

export default PortalDialogDefault.instance;